console.log('editor.js');